<template>
  <div class="binding_main">
    <div class="binding_bg"></div>
    <div class="binding_box">
      <div class="binding_title">
        <span>添加绑定</span>
        <el-button style="float:right; margin-top: -7px;" @click="backHome">返回</el-button>
      </div>
      <div class="binding_step">
        <el-steps :active="active" align-center finish-status="finish">
          <el-step title="填写子女信息"></el-step>
          <el-step title="验证账户信息"></el-step>
          <el-step title="绑定成功"></el-step>
        </el-steps>
        <div class="binding_mian_box">
          <el-form v-if="active == 1" :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="100px" class="demo-dynamic">
            <el-form-item
              prop="childrenInfo"
              label="子女信息"
              :rules="[{ required: true, message: '必须填写子女信息', trigger: 'blur' }]"
            >
              <el-input v-model="dynamicValidateForm.childrenInfo" placeholder="请输入身份证/学籍号/学号"></el-input>
            </el-form-item>
            <el-form-item
              prop="familyRelation"
              label="子女关系"
              :rules="[{ required: true, message: '必须填写子女关系', trigger: 'change' }]"
            >
              <el-select v-model="dynamicValidateForm.familyRelation" placeholder="绑定子女关系">
                <el-option 
                  v-for="f in familyRelations"
                  :key="f.id"
                  :label="f.seiName"
                  :value="f.seiName"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div v-else-if="active == 2" class="list_children" v-loading="loading" element-loading-text="拼命加载中" >
            <div class="list_img">
              <img v-if="childrenInfo.avatar" :src="avatar_url + childrenInfo.avatar">
              <img src="./img/role/role2.png">
            </div>
            <div class="list_info">
              <p>{{childrenInfo.userName}}<span>({{dynamicValidateForm.familyRelation}})</span></p>
              <p>{{childrenInfo.gradeName}}/
                {{childrenInfo.className}}/
                <span v-if="childrenInfo.sexCode">男</span>
                <span v-else>女</span>
              </p>
              <p :title="childrenInfo.campusName">{{childrenInfo.campusName}}</p>
              <p>唯一编码：{{childrenInfo.idCard}}</p>
            </div>
          </div>
          <div v-else class="binding_success">
            <div class="success_icon">
              <i class="el-icon-check"></i>
            </div>
            <p>绑定成功</p>
            <span>{{second}}s后返回</span>
          </div>
        </div>
        <div class="binding_btn">
          <el-button type="primary" v-if="active == 1" @click="next('dynamicValidateForm')">下一步</el-button>
          <el-button v-if="active == 2" @click="pre">上一步</el-button>
          <el-button type="primary" v-if="active == 2" @click="binding">确认绑定 </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
 window['bin_Ding'] = {
    name: "bin_Ding",
    props:{
      loingType:{ type: String }
    },
    data () {
      return {
        active: 1,
        dynamicValidateForm: {
          childrenInfo: '',
          familyRelation:''
        },
        second: 5,
        avatar_url: window.systemParameter.FILE_SYSTEM_URL + "/api/image/thumbnail/",//图片显示地址
        childrenInfo:{},
        familyRelations:[],
        loading: false,
      }
    },
    mounted() {
      let vm= this
      http.get(globel_url + '/platform/enum/queryByCodes/JiaTingGuanXi').then(xhr=>{
        vm.familyRelations = xhr.data
      })
    },
    methods: {
    backHome(){
      let vm = this
      if(vm.loingType == '1'){
        this.logout()
      }else{
        vm.$emit('backHome')
      }
    },
    next(formName){      
      let vm = this
      http.get( globel_url + '/platform/mobile/student?simKey='+ vm.dynamicValidateForm.childrenInfo ).then(xhr=>{
        // if(xhr.data.data&&xhr.data.data.length>0){
          xhr.data.data[0].avatar = ''
        // }
        vm.childrenInfo = xhr.data.data[0]
        vm.loading = false
      })
    
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (vm.active++ > 2) vm.active = 3;
        } else {
          return false;
        }
      });
      
    },
    pre(){
      let vm = this
      vm.active = 1;
    },
    binding(){
      let vm = this
      let childLists = []
      let obj = {
        familyRelation : vm.familyRelation,
        idCard : vm.childrenInfo.idCard,
        learnNo : vm.childrenInfo.learnNo,
        parentId:'',
        familyAddress:'',
        studentId:'',
        studentName:'',
        schoolName:'',
        choosed: false,
      }
      childLists[0] = obj
      let UserProfile = {
        id: window.appframe.$store.state.userInfo.id,
        childList: childLists
      }
      http.post( globel_url + '/platform/mobile/user/bind/' , UserProfile).then( xhr =>{
        vm.active = 3;
        let interval = setInterval(_=>{
          vm.second--
          if(vm.second == 0){
            vm.backHome()
            clearInterval(interval);
          }
        },1000)
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          return false;
        }
      });
    },
  }
 }
export default window['bin_Ding']
</script>
<style lang="less" scoped>
  .binding_main{ background: #ebeff2; position: relative; width: 100%; height: 100%;
    .binding_bg{ position: fixed; left: 0; right: 0; top: 0; bottom: 0; background: #ebeff2; }
    .binding_box{ width: 1000px; height: 600px; position: fixed; left: 50%; top: 50%; margin: -300px 0 0 -500px; background: #fff; box-shadow: 0 0 5px rgba(0,0,0,.5); 
      .binding_title{ height: 53px; border-bottom: 1px solid #e5e7ea; padding: 17px 16px; box-sizing: border-box;
        >span{ font-size: 18px; color: #333; float: left; }
      }
      .binding_step{ width: 485px; margin: 90px auto 0; 
        .binding_mian_box{ margin-top:65px;         
          .list_children{ width: 420px; box-sizing: border-box; padding: 15px; height: 120px; margin: auto; 
            border-radius: 8px; position: relative; overflow: hidden; background: url("./img/default.png");
            .list_img{ float: left; margin-left: 16px; height: 70px; width: 70px; margin-top: 9px;
              >img{ height: 70px; width: 70px; border-radius: 50%; }
            }
            .list_info{ color: #fff; padding-left: 102px; height: 86px; margin-top: 4px;
              >p:first-child{ font-size: 18px; font-weight: 700; margin-bottom: 10px; 
                span{ font-size: 12px; margin-left: 4px; }
              }
              >p{ height: 20px; font-size: 14px; }
              >p:nth-child(2){ overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
            }
          }
        }
        .binding_success{ width: 100px; text-align: center; margin: auto; padding-top: 35px;
          .success_icon{ width: 80px; height: 80px; margin: auto; line-height: 80px; border-radius: 50%; font-weight: 700; border: 5px solid #95e8b4; 
            background: #2bd169; color: #fff; font-size: 32px; }
          >p{ font-size: 24px; color: #333; margin: 24px 0 16px; }
          >span{ font-size: 10px; color: #999;}
        }
        .binding_btn{ margin-top: 40px; text-align: center; }
      }
    }
  }
</style>
<style scoped>
  .binding_btn>.el-button{ width: 120px ; height: 40px;}
  .binding_mian_box>.el-form>.el-form-item>.el-form-item__content>.el-input>input{ color: #666; }
  .binding_mian_box>.el-form>.el-form-item>.el-form-item__content>.el-input>input::-webkit-input-placeholder { color: #666; }
</style>




// WEBPACK FOOTER //
// src/components/appframe/binding.vue